import React from 'react';
import { Menu } from 'antd';
import {
  TableOutlined,
  DashboardOutlined,
  BarChartOutlined,
  UserOutlined,
  TeamOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import '../styles/Sidebar.scss';
import bcdLogo from '../assets/finkraft_logo_new.png';
import { Link } from 'react-router-dom';

const Sidebar = ({isKgrpUser}) => {
  return (
    <div className="custom-sidebar">


      <Menu
        mode="vertical"
        defaultSelectedKeys={['table']}
        className="sidebar-menu"
      >
        <div className="sidebar-logo">
          <img src={bcdLogo} alt="BCD Logo" />
        </div>
        <Menu.Item key="table" icon={<TableOutlined />}>
          <Link to="/dashboard">Table</Link> {/* ← Navigates to DashboardTable */}
        </Menu.Item>
      {/* Show Master View only if user domain is kgrp.in */}
        {isKgrpUser && (
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            <Link to="/master-view">Master View</Link>
          </Menu.Item>
        )}


        {/* <Menu.Item key="charts" icon={<BarChartOutlined />}>
          Charts
        </Menu.Item>
        <Menu.Item key="customer" icon={<UserOutlined />}>
          Customer
        </Menu.Item> */}
      </Menu>

      {/* <div className="sidebar-bottom">
        <Menu mode="vertical" selectable={false}>
          <Menu.Item key="workspace" icon={<TeamOutlined />}>
            Workspace
          </Menu.Item>
          <Menu.Item key="members" icon={<TeamOutlined />}>
            Members
          </Menu.Item>
          <Menu.Item key="settings" icon={<SettingOutlined />}>
            Settings
          </Menu.Item>
          <Menu.Item key="help" icon={<QuestionCircleOutlined />}>
            Help
          </Menu.Item>
        </Menu>
      </div> */}
    </div>
  );
};

export default Sidebar;
